import React from "react";
import cartfff from '../../assets/images/cartfff.png';
import { useTranslation } from 'react-i18next';

function Carttitle({ onClearCart, showClearButton, handleCancel, handleCart, clearCartPopup }) {
  const { t } = useTranslation();
  return (

    <div className="Favourites_title">
      <div className="Favourites_title_l">
        <img className="cartfff" src={cartfff} alt="" width="35" height="36" />
        <h2>{t('cart')}</h2>
      </div>
      {showClearButton && (
        <div className="cart-actions">
          <button onClick={handleCart} className="clear-cart-btn">
            {t("clear_cart")}
          </button>
        </div>
      )}

      {clearCartPopup && (
        <div className="darkpopup active notification-popup">
          <div className="darkpopup_inner">
            <div className="text">
              {t("clear_cart_confirm_message")}
            </div>
            <div className="yesnobtn">
              <button
                className="whitebtn cancelbtn"
                onClick={handleCancel}
              > {t("cancel")}
              </button>
              <button type="button" className="whitebtn cancelbtn" onClick={onClearCart}>
                {t("proceed")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Carttitle;
